import Vue from 'vue'
import Router from 'vue-router'
import store from './store/index.js'
import DashboardLayout from '@/layout/DashboardLayout'
import AuthLayout from '@/layout/AuthLayout'
import HomeLayout from '@/layout/HomeLayout'
Vue.use(Router)


const ifNotAuthenticated = (to, from, next) => {
  if (!store.getters.isLoggedIn) {
    next()
    return
  }
  next('/')
}

const ifAuthenticated = (to, from, next) => {
  if (store.getters.isLoggedIn) {
    next()
    return
  }
  next('/login')
}

export default new Router({
  linkExactActiveClass: 'active',  
  routes: [
    {
      path: '/',
      redirect: 'dashboard',
      component: DashboardLayout,
      children: [
        {
          path: '/dashboard',
          name: 'dashboard',         
          component: () => import(/* webpackChunkName: "demo" */ './views/Dashboard.vue'),
          beforeEnter: ifAuthenticated,
        },
        {
          path: '/icons',
          name: 'Student File',
          component: () => import(/* webpackChunkName: "demo" */ './views/Icons.vue'),
          beforeEnter: ifAuthenticated,
        },
        {
          path: '/profile',
          name: 'profile',
          component: () => import(/* webpackChunkName: "demo" */ './views/UserProfile.vue'),
          beforeEnter: ifAuthenticated,
        },        
        {
          path: '/church',
          name: 'church',
          component: () => import(/* webpackChunkName: "demo" */ './views/Admin/Church.vue'),
          beforeEnter: ifAuthenticated,
        },
        {
          path: '/member',
          name: 'member',
          component: () => import(/* webpackChunkName: "demo" */ './views/Church/Member.vue'),
          beforeEnter: ifAuthenticated,
        },
        {
          path: '/family',
          name: 'family',
          component: () => import(/* webpackChunkName: "demo" */ './views/Church/Family.vue'),
          beforeEnter: ifAuthenticated,
        },
        {
          path: '/department',
          name: 'department',
          component: () => import(/* webpackChunkName: "demo" */ './views/Church/Department.vue'),
          beforeEnter: ifAuthenticated,
        },
        {
          path: '/event',
          name: 'event',
          component: () => import(/* webpackChunkName: "demo" */ './views/Church/Event.vue'),
          beforeEnter: ifAuthenticated,
        },
        {
          path: '/notification',
          name: 'notification',
          component: () => import(/* webpackChunkName: "demo" */ './views/Church/Notification.vue'),
          beforeEnter: ifAuthenticated,
        },
        {
          path: '/message',
          name: 'notification',
          component: () => import(/* webpackChunkName: "demo" */ './views/Church/Message.vue'),
          beforeEnter: ifAuthenticated,
        },
        
      ]
    },
    {
      path: '/',
      redirect: 'login',
      component: AuthLayout,
      children: [
        {
          path: '/login',
          name: 'login',
          component: () => import(/* webpackChunkName: "demo" */ './views/Account/Login.vue'),
          beforeEnter: ifNotAuthenticated,
        },        
        {
          path: '/retrievepassword',
          name: 'retrieve password',
          component: () => import(/* webpackChunkName: "demo" */ './views/Account/Retrievepassword.vue'),
          beforeEnter: ifNotAuthenticated,
        },
        {
          path: '/changepassword',
          name: 'change password',
          component: () => import(/* webpackChunkName: "demo" */ './views/Account/Changepassword.vue'),
          beforeEnter: ifNotAuthenticated,
        },       
        {
          path: '/privacy',
          name: 'Privacy Policy',
          component: () => import(/* webpackChunkName: "demo" */ './views/Privacy.vue'),
          beforeEnter: ifNotAuthenticated,
        },       
        
      ]
    },
    {
      path: '/',
      redirect: 'home',
      component: HomeLayout,
      children: [
        {
          path: '/home',
          name: 'home',
          component: () => import(/* webpackChunkName: "demo" */ './views/Home.vue'),
          beforeEnter: ifAuthenticated,
        },       
      ]
    },
   
  ]
})

